// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__eVafi","savePackageButton":"ClientWallet_savePackageButton__2Nu15"};